// extracted by mini-css-extract-plugin
export default {"noImage":"AwardRow_noImage__1-Bk9","noProfileImg":"AwardRow_noProfileImg__KAQ-c","cursorPointer":"AwardRow_cursorPointer__-7ZbA"};